import { createReducer } from "@reduxjs/toolkit";
import { NavPoint } from "@redux/navPoint/NavPoint";
import { hydrateStore } from "@actions/useHydrateStore";
import { refreshNavPoint } from "@actions/useRefreshNavPoint";
import { updateNavPoint } from "@actions/useUpdateNavPoint";

export default createReducer<NavPoint>(null, builder => {
  builder
    .addCase(hydrateStore, (state, action) => {
      if (action.payload.navPoint) {
        return action.payload.navPoint as NavPoint;
      }
      return state;
    })
    .addCase(updateNavPoint, (state, action) => {
      return { ...state, ...action.payload };
    })
    .addCase(refreshNavPoint, (_state, action) => {
      return action.payload;
    });
});
